import React from "react";
import { useLang } from "@/App";
import { brandList } from "@/i18n";

export default function Brands() {
  const { t } = useLang();
  return (
    <section id="marcas" className="py-20 md:py-24 bg-slate-50 border-y border-slate-100" data-testid="brands-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-sm font-bold uppercase tracking-widest text-sky-700">{t.brands.kicker}</p>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight text-blue-950">{t.brands.title}</h2>
          <p className="mt-4 text-base md:text-lg text-slate-600">{t.brands.subtitle}</p>
        </div>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-5 md:gap-6">
          {brandList.map((b, i) => (
            <div key={i} className="h-20 md:h-24 w-40 md:w-48 flex items-center justify-center" data-testid={`brand-${b.name.toLowerCase().replace(/\s+/g, "-")}`}>
              <img src={b.logo} alt={b.name} loading="lazy" className="h-full w-full object-contain" style={{mixBlendMode: 'multiply', transform: (b.name === 'Philips' || b.name === 'Phonak') ? 'scale(1.5)' : 'scale(1)'}} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
